import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {concatMap, map, switchMap, take} from 'rxjs/operators';
import {AppState} from '@iw-shared/store/state/app.state';
import {Store} from '@ngrx/store';
import * as UserActions from '@iw-shared/store/actions/user.action';
import * as AuthenticationActions from '@iw-shared/store/actions/authentication.action';
import * as StorageActions from '@iw-shared/store/actions/storage.action';
import {AuthenticationService} from "@iw-shared/core/services/authentication.service";
import {setNotification} from "@iw-shared/store/actions/global.actions";
import {EMPTY} from "rxjs";

@Injectable()
export class UserEffects {

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private authenticationService: AuthenticationService) {
  }

  setUser$ = createEffect(() => this.actions$.pipe(
      ofType(UserActions.setUser),
      switchMap((action) => {
        let endpoint: 'admin' | 'account' | 'productDB' | undefined = undefined;
        this.store.select(state => state.storage.APIEndpoint).pipe(
          take(1)
        ).subscribe(
          r => {
            if (r) {
              endpoint = r;
            }
          }
        );
        if (!endpoint) {
          this.store.dispatch(setNotification({notification: 'Endpoint undefined', notificationType: 'error'}));
          return EMPTY;
        }

        switch (endpoint) {
          case 'admin':
            return this.authenticationService.getUsersAccount(action.userId)
              .pipe(
                map((r) => {
                  if (r.result?.accountBackendUsers?.data[0]) {
                    return UserActions.setUserSuccess(
                      {user: r.result?.accountBackendUsers.data[0]}
                    )
                  } else {
                    console.log('setUser$ AuthenticationActions.logout()');
                    return AuthenticationActions.logout();
                  }
                })
              );
          default:
            return this.authenticationService.getUsers(action.userId)
              .pipe(
                map((r) => {
                  if (r.result?.users?.data[0]) {
                    return UserActions.setUserSuccess(
                      {user: r.result?.users.data[0]}
                    )
                  } else {
                    console.log('setUser$ AuthenticationActions.logout()');
                    return AuthenticationActions.logout();
                  }
                })
              );
        }
      })
    )
  );

  setUserSuccess = createEffect(() => this.actions$.pipe(
    ofType(UserActions.setUserSuccess),
    map((action) => {
      return StorageActions.userId({userId: action.user.id});
    })
  ));


}
